import { render, staticRenderFns } from "./DisplayErrors.vue?vue&type=template&id=13de6e0f&scoped=true&"
import script from "./DisplayErrors.vue?vue&type=script&lang=js&"
export * from "./DisplayErrors.vue?vue&type=script&lang=js&"
import style0 from "./DisplayErrors.vue?vue&type=style&index=0&id=13de6e0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de6e0f",
  null
  
)

export default component.exports